<template>
  <v-dialog v-model="dialog" max-width="100%">
     <v-card >
        <v-card-title class="headline">
           <span>
           File Preview
           </span>
           <i class="mdi mdi-close close-btn"  @click="handleClose"></i>
        </v-card-title>
     </v-card>
     <v-content >
      <div class="modal-content">
        <filePreview :url="url" :key="url"/>
      </div>
     </v-content>
  </v-dialog>
</template>
<script>
import filePreview from './commonComponents/filePreview.vue'
export default {
  name: 'filePreviewModal',
  components: {
    filePreview
  },
  props: {
    dialog: Boolean,
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      url: null
    }
  },
  methods: {
    handleClose () {
      this.dialog = false
    }
  },
  watch: {
    dialog (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
    data: {
      immediate: true,
      handler (newVal) {
        if (!newVal) return
        const { file_path: fileLink } = newVal
        this.url = fileLink
      }
    }
  }
}
</script>
<style scoped>
.headline{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-btn{
  padding-inline: 5px;
  border-radius: 50%;
}
.close-btn:hover{
  cursor: pointer;
  background: rgb(var(--secondary-color));
}
::v-deep .v-dialog{
  max-width: 100% !important;
  overflow: hidden !important;
}
::v-deep .v-content{
  height: 90vh !important;
  padding:16px 0px;
}
::v-deep .v-card{
  box-shadow: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid #e5e7eb;
}
.modal-content {
  height: 100%;
  width: 100%;
}
.scrolling-page{
  height: 90%;
}
</style>
